import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";
import store from "../store"; // 引入Vuex store
import { isPathEnabled, isPathEnabledForHotel, isRestaurantModuleOnlyPath } from "@/utils/featureGates";
Vue.use(VueRouter);

const LAST_ROUTE_STORAGE_KEY = "wtk:lastRoute";
const WHITE_LIST = ["/login", "/redirect", "/reset-password"];
// 品牌模式（auth.selectedBrandName 非空）能进的页面：品牌模式侧栏里有的（品牌页、设置、帮助中心、AI 问答）
// 加上登录、选择页这类公共页，子路径一起算。其余页面一律回 BRAND_MODE_HOME（见 beforeEach 的 2.8）
const BRAND_MODE_HOME = "/BrandOverview2";
const BRAND_MODE_PATHS = [
  BRAND_MODE_HOME, "/BrandOverview3", "/setting", "/StaffManagement", "/FAQ", "/chat",
  "/select-hotel", ...WHITE_LIST,
];

function shouldPersistRoute(route) {
  return route && route.path && !WHITE_LIST.includes(route.path) && route.path !== "/";
}

function getLastRouteFromStorage() {
  try {
    return window.localStorage.getItem(LAST_ROUTE_STORAGE_KEY) || "";
  } catch (error) {
    console.warn("读取最后访问路由失败:", error);
    return "";
  }
}

// 定义路由
export const routes = [
  // 2. Home (关键修复)
  {
    path: "",
    component: Layout,
    hidden: false,
    redirect: "/index", // 自动重定向到 /index
    name:'Hotel Overview',
    meta: {title: "Hotel Overview", icon: "dashboard", affix: true, noCache: true,},
    children: [
      {
        path: "/index", // absolute path
        component: () => import("@/views/hotel/index.vue"),
        name: "Index",
        meta: {title: "Hotel Dashboard"},
      },
      {
        path: "/NeedsAttention", // absolute path
        component: () => import("@/views/NeedsAttention/index.vue"),
        name: "NeedsAttention",
        meta: {title: "Case Management"},
      },
      {
        path: "/reviews",
        component: () => import("@/views/ReviewsReply/Reviews/index"),
        name: "Reviews",
        meta: { title: "Reviews" },
      },
      // 旧路径，邮件 / 书签里的链接还在用，保留重定向（query 会带过去）
      {
        path: "/ReplySettingIndex",
        redirect: "/reviews",
      },
      {
        path: "/ReplyLibrary",
        component: () => import("@/views/ReplyLibrary/index"),
        name: "ReplyLibrary",
        meta: { title: "Reply Library" },
      },
        // {
        //   path: "/ReplyLike",
        //   component: () => import("@/views/ReviewsReply/ReplyLikeTemplate/index"),
        //   name: "ReplyLike",
        //   meta: { title: "ReplyLike" },
        // },
      {
        path: "/ReplySetting",
        component: () => import("@/views/ReviewsReply/ReplySetting/index"),
        name: "Reply Setting",
        meta: { title: "Reply Setting" },
      },
      {
        path: "/competitors/overview",
        component: () => import("@/views/competitors/newIndex.vue"),
        name: "CompetitorsOverview",
        meta: { title: "Competitors", competitorsSection: "overview" },
      },
      {
        path: "/competitors/analysis",
        component: () => import("@/views/competitors/newIndex.vue"),
        name: "CompetitorsAnalysis",
        meta: { title: "Competitors", competitorsSection: "analysis" },
      },
      {
        path: "/competitors",
        redirect: "/competitors/overview",
      },
    ],
  },
  {
    path: "",
    component: Layout,
    // hidden: false,
    hidden: true,
    name:'Restaurant',
    meta: {title: "Restaurant", icon: "Restaurant", affix: true, noCache: true,},
    children: [
      {
        path: "/RestaurantDashboard", // absolute path
        component: () => import("@/views/RestaurantDashboard/index.vue"),
        name: "RestaurantDashboard",
        meta: {title: "Restaurant Dashboard"},
      },
      {
        path: "/RestaurantReviewsIndex",
        component: () => import("@/views/RestaurantReviews/index"),
        name: "RestaurantReviewsIndex",
        meta: { title: "Reviews" },
      },
    ],
  },
  {
    path: "/Reports",
    component: Layout,
    hidden: false,
    meta: {title: "Reports", icon: "reports"},
    children: [
      {
        path: "/Reports",
        component: () => import("@/views/HotelReports/index.vue"),
        name: "Reports",
        meta: { title: "Reports" },
      },
    ],
  },
  {
    path: "/QualityStandards",
    component: Layout,
    hidden: false,
    meta: { title: "QualityStandards", icon: "quality-standards" },
    children: [
      {
        path: "/QualityStandards",
        component: () => import("@/views/QualityStandards/index.vue"),
        name: "QualityStandards",
        meta: { title: "QualityStandards" },
      },
    ],
  },
  // 竞对半年报（Competitive Half-Year）。同样只对 Kimpton Maa-Lai Bangkok 开放。
  {
    path: "/MarketHalfYear",
    component: Layout,
    hidden: false,
    meta: { title: "MarketHalfYear", icon: "Competition" },
    children: [
      {
        path: "/MarketHalfYear",
        component: () => import("@/views/MarketHalfYear/index.vue"),
        name: "MarketHalfYear",
        meta: { title: "MarketHalfYear" },
      },
    ],
  },
  // F&B 聚合半年报（餐厅模块）。同样只对 Kimpton Maa-Lai Bangkok 开放，见 featureGates.js。
  {
    path: "/FnbHalfYear",
    component: Layout,
    hidden: false,
    meta: { title: "FnbHalfYear", icon: "reports" },
    children: [
      {
        path: "/FnbHalfYear",
        component: () => import("@/views/FnbHalfYear/index.vue"),
        name: "FnbHalfYear",
        meta: { title: "FnbHalfYear" },
      },
    ],
  },
  // 半年报（Half-Year Review）。只对 Kimpton Maa-Lai Bangkok 开放，见 featureGates.js 的
  // HOTEL_ONLY_PATHS —— 侧边栏和上面的路由守卫都读那一处。
  {
    path: "/HalfYearReview",
    component: Layout,
    hidden: false,
    meta: { title: "HalfYearReview", icon: "reports" },
    children: [
      {
        path: "/HalfYearReview",
        component: () => import("@/views/HalfYearReview/index.vue"),
        name: "HalfYearReview",
        meta: { title: "HalfYearReview" },
      },
    ],
  },
  {
    path: "/PortfolioBriefing",
    component: Layout,
    hidden: false,
    meta: {title: "PortfolioBriefing", icon: "reports"},
    children: [
      {
        path: "/PortfolioBriefing",
        component: () => import("@/views/HotelReports/index.vue"),
        name: "PortfolioBriefing",
        meta: { title: "PortfolioBriefing" },
      },
    ]
  },
  {
    path: "/Survey",
    component: Layout,
    redirect: "/Survey/DuringStay",
    meta: { title: "Surveys", icon: "survey" },
    children: [
      {
        path: "/Survey/DuringStay",
        component: () => import("@/views/survey/index.vue"),
        name: "SurveyDuringStay",
        meta: { title: "During Stay", stayType: "during" },      },
      {
        path: "/Survey/PostStay",
        component: () => import("@/views/survey/PostStay.vue"),
        name: "SurveyPostStay",
        meta: { title: "Post Stay", stayType: "post" },      },
      {
        path: "/Survey/Detail",
        component: () => import("@/views/survey/SurveyDetail.vue"),
        name: "SurveyDetail",
        meta: { title: "Survey Detail" },      },
    ],
  },
  {
    path: "/BrandOverview",
    component: Layout,
    // hidden: false,
    hidden: true,
    meta: {title: "BrandOverview", icon: "BrandOverview"},
    children: [
      {
        path: "/BrandOverview",
        component: () => import("@/views/BrandOverview/index"),
        name: "BrandOverview",
        meta: { title: "BrandOverview" },      },
    ],
  },
  {
    path: "/BrandOverview2",
    component: Layout,
    hidden: false,
    meta: { title: "BrandOverview2", icon: "BrandOverview" },
    children: [
      {
        path: "/BrandOverview2",
        component: () => import("@/views/BrandOverview2/index"),
        name: "BrandOverview2",
        meta: { title: "BrandOverview2" },      },
    ],
  },
  {
    path: "/BrandOverview3",
    component: Layout,
    hidden: false,
    meta: { title: "BrandOverview3", icon: "BrandOverview" },
    children: [
      {
        path: "/BrandOverview3",
        component: () => import("@/views/BrandOverview3/index"),
        name: "BrandOverview3",
        meta: { title: "BrandOverview3" },      },
      {
        path: "/BrandOverview3/hotel/:hotelId",
        component: () => import("@/views/BrandOverview3/HotelProfile"),
        name: "BrandOverview3HotelProfile",
        hidden: true,
        meta: { title: "Hotel Profile" },
      },
      {
        path: "/BrandOverview3/hotel/:hotelId/outlet/:outletId",
        component: () => import("@/views/BrandOverview3/OutletProfile"),
        name: "BrandOverview3OutletProfile",
        hidden: true,
        meta: { title: "Outlet Profile" },
      },
    ],
  },
  {
    path: "/setting",
    component: Layout,
    hidden: false,
    meta: { title: "Settings", icon: "set" },
    children: [
      {
        path: "/setting",
        component: () => import("@/views/setting/index"),
        name: "SettingAlerts",
        meta: { title: "Settings" },
      },
    ],
  },
  {
    // Staff Management is a tab of Settings now: views/setting/Staff. The old page URL
    // opens that tab. Still gated in utils/featureGates.js (staging only) and by the
    // STAFF_MANAGEMENT menu item.
    path: "/StaffManagement",
    hidden: true,
    redirect: { path: "/setting", query: { tab: "staff" } },
  },
  {
    // Connections (link the current hotel / restaurant to its Google and Tripadvisor
    // listings) is a tab of Settings now: views/setting/Connections. The old page URL
    // opens that tab. Gated in utils/featureGates.js (staging only) and by the
    // CONNECTIONS menu item.
    path: "/Connections",
    component: Layout,
    hidden: true,
    redirect: { path: "/setting", query: { tab: "connections" } },
    children: [
      {
        // Google's OAuth redirect URI (api: connections.google.redirect-uri). Must stay
        // byte-for-byte equal to the URI registered on the Google OAuth client.
        path: "/Connections/google/callback",
        component: () => import("@/views/setting/Connections/GoogleCallback"),
        name: "ConnectionsGoogleCallback",
        meta: { title: "Connections" },
      },
    ],
  },
  {
    path: "/FAQ",
    component: Layout,
    hidden: false,
    // hidden: true,
    meta: { title: "Help Center (FAQ)", icon: "FAQ" },
    children: [
      {
        path: "/FAQ",
        component: () => import("@/views/FAQ/index"),
        name: "FAQ",
        meta: { title: "Help Center (FAQ)" },
      },
    ],
  },
  {
    path: "/log",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/log",
        component: () => import("@/views/log/index"),
        name: "log",
      },
    ],
  },
  {
    // AI Chat. Visibility/access is gated centrally via featureGates (the global
    // route guard blocks direct-URL access when the aiChat feature is off).
    path: "/chat",
    component: Layout,
    hidden: true,
    children: [
      {
        // Conversation id rides as a QUERY param (/chat?c=<id>), NOT a path param —
        // AppMain keys <router-view> on $route.path, so a path change would remount
        // the page and kill an in-flight streaming answer. Query changes don't.
        path: "/chat",
        component: () => import("@/views/Chat/index.vue"),
        name: "Chat",
        meta: { title: "AI Chat" },
      },
    ],
  },
  // {
  //   path: "/ceshi",
  // hidden: true,
  //   component: () => import("@/views/ceshi.vue"),
  // },

  //ReplySettingIndex
/*  {
    path: "/reviews-and-reply",
    meta: { title:"Reviews & Reply",  icon: "reviews" },
    component: Layout,
    hidden: false,
    redirect: "/index", // 自动重定向到 /index
    children: [
    ],
  },*/
/*  {
    path: "/competitors",
    component: Layout,
    hidden: false,
    meta: { title: "Competitors", icon: "Competitors" },
    children: [
    ],
  },*/

  {
    path: "/login",
    component: () => import(/* webpackChunkName: "login" */ "@/views/login/LoginView.vue"),
    hidden: true,
    meta: { title: "Login" },
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect"),
      },
    ],
  },

  {
    path: "/select-hotel", // 酒店选择页面路由
    name: "HotelSelect",
    component: () => import("@/views/hotel/components/HotelSelector.vue"),
    meta: { requiresAuth: true, icon: "" }, // 需要登录才能访问
    hidden: true,
  },

  {
    path: "/reset-password",
    hidden: true,
    component: () => import("@/views/login/ResetPassword.vue"),
  },
  // 404页面
  {
    path: "*", // 匹配所有未定义的路由
    component: Layout,
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/error/404"),
        name: "NotFound",
        meta: { title: "404 Not Found", icon: "" },
      },
    ],
  },

  // {
  //   path: "/social-media",
  //   component: Layout,
  //   meta: { title: "Social Media", icon: "social" },
  //   alwaysShow: true,
  //   children: [
  //     {
  //       path: "",
  //       redirect: "feed",
  //       hidden: true,
  //     },
  //     {
  //       path: "analytics",
  //       component: () => import("@/views/socialMedia/index"),
  //       name: "SocialMediaAnalytics",
  //       meta: { title: "Analytics", icon: "social" },
  //     },
  //     // {
  //     //   path: "feed",
  //     //   component: () => import("@/views/socialMedia/feed/index"),
  //     //   name: "SocialMediaFeed",
  //     //   meta: { title: "Feed", icon: "feed", affix: true },
  //     // },
  //   ],
  // },
  // {
  //   path: "/restaurants-and-bars",
  //   component: Layout,
  //   meta: { title: "Restaurants & Bars", icon: "reviews" },
  //   alwaysShow: true,
  //   children: [
  //     {
  //       path: "",
  //       redirect: "bars",
  //       hidden: true,
  //     },
  //     {
  //       path: "bars",
  //       component: () => import("@/views/hotelRestaurantsBars/index"),
  //       name: "HotelRestaurantsBars",
  //       meta: { title: "Bars", icon: "reply" },
  //     },
  //   ],
  // },
  // {
  //   path: "/reviews-and-reply",
  //   component: Layout,
  //   meta: { title: "Reviews & Reply", icon: "reviews" },
  //   alwaysShow: true,
  //   children: [
  //     {
  //       path: "reply-template",
  //       component: () => import("@/views/ReviewsReply/index"),
  //       name: "ReviewsAndReply",
  //       meta: { title: "Reply Template", icon: "reply" },
  //     },
  //   ],
  // },
  // {
  //   path: "/competitors",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "",
  //       component: () => import("@/views/competitors/index"),
  //       name: "Competitors",
  //       meta: { title: "Competitors", icon: "com" },
  //     },
  //   ],
  // },
  // {
  //   path: "/inside-out-staff-logs",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "",
  //       component: () => import("@/views/staffLogs/index"),
  //       name: "InsideOutStaffLogs",
  //       meta: { title: "Inside-out Staff Logs", icon: "inside" },
  //     },
  //   ],
  // },
  // {
  //   path: "/crm-and-profiles",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "",
  //       component: () => import("@/views/staffLogs/index"),
  //       name: "CRMAndProfiles",
  //       meta: { title: "CRM & Profiles", icon: "crm" },
  //     },
  //   ],
  // },
  // {
  //   path: "/reporting-tools",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "",
  //       component: () => import("@/views/staffLogs/index"),
  //       name: "ReportingTools",
  //       meta: { title: "Reporting Tools", icon: "report" },
  //     },
  //   ],
  // },

];




// 创建路由实例
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  strict: false,
  routes
});

// Restore token from storage exactly once, before any route guard evaluates auth state.
// Without this, after a page refresh Vuex state is empty and the guard always redirects to /login.
let tokenRestored = false;

// 导航守卫 - 全局前置守卫
// 导航守卫 - 简化逻辑
// 全局前置守卫 - 优化版
router.beforeEach(async (to, from, next) => {
  // Restore persisted token on first navigation (restoreToken is synchronous)
  if (!tokenRestored) {
    store.dispatch("auth/restoreToken");
    tokenRestored = true;
  }

  // 强制去除URL末尾斜杠（根路径/除外）
  if (to.path.endsWith("/") && to.path !== "/") {
    const newPath = to.path.slice(0, -1); // 去除末尾斜杠
    next(newPath + (to.search || "") + (to.hash || ""));
    return;
  }

  // 记录开始导航的时间，用于性能监控
  const start = Date.now();

  // 从Vuex获取认证状态（推荐使用Vuex而非直接操作localStorage）
  const isAuthenticated = store.getters["auth/isAuthenticated"];

  // 白名单路由 - 不需要登录即可访问的路由
  const whiteList = WHITE_LIST;

  try {
    // 1. 检查是否需要重定向到登录页
    if (!isAuthenticated && !whiteList.includes(to.path)) {
      // 未登录且访问需要权限的页面，重定向到登录页
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
      return;
    }

    // 2. 已登录但访问登录页，重定向到首页
    if (isAuthenticated && to.path === "/login") {
      next({ path: "/" });
      return;
    }

    // 2.5 Feature gate: pages disabled in this environment (staging-only, or a
    // feature flag that's off) aren't reachable by direct URL — see featureGates.js.
    if (isAuthenticated && !isPathEnabled(to.path)) {
      next({ path: "/index" });
      return;
    }

    // 2.6 同上，但按「当前选中的酒店」挡：这类页面的数据只为特定酒店准备（见
    // featureGates.js 的 HOTEL_ONLY_PATHS），换一家酒店直接输 URL 也不该进得去。
    if (isAuthenticated) {
      const currentHotel = store.getters["hotel/currentHotel"];
      // restaurantList / selectedRestaurantId 都是持久化的（store/index.js），刷新页面直接进 URL 时也拿得到
      const currentRestaurant = store.getters["restaurant/currentRestaurant"];
      if (!isPathEnabledForHotel(to.path, currentHotel && currentHotel.hotelName, currentRestaurant)) {
        next({ path: "/index" });
        return;
      }
    }

    // 2.7 餐厅模块专属页（如 /FnbHalfYear）在酒店模式下不能进：从餐厅切回酒店、
    // 登录后恢复上次访问地址等场景，都可能把酒店模式带回这类页面，导致酒店展示餐厅数据。
    // 品牌模式不联动 hotel/isHotel，这里不管它。
    if (
      isAuthenticated
      && store.state.hotel.isHotel
      && !store.state.auth.selectedBrandName
      && isRestaurantModuleOnlyPath(to.path)
    ) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn(`[router] 酒店模式下访问餐厅专属页 ${to.path}，已重定向到 /index`);
      }
      next({ path: "/index" });
      return;
    }

    // 2.8 品牌模式只能进品牌模式侧栏里有的页面（品牌页、设置、帮助中心、AI 问答）和登录 / 选择页这类公共页。
    // 品牌模式是持久化的，访问 / 时又会恢复上次地址（比如 /index），不拦的话会停在酒店页、侧栏却是品牌菜单，
    // 单品牌 cluster 的侧栏连回品牌页的入口都没有。只在品牌页本身能进时才跳（正式环境 /BrandOverview2 还是
    // 测试环境专属，上面 2.5 会把它打回 /index，这里再跳回去就成了死循环）
    if (
      isAuthenticated
      && store.state.auth.selectedBrandName
      && !BRAND_MODE_PATHS.some((p) => to.path === p || to.path.startsWith(p + "/"))
      && isPathEnabled(BRAND_MODE_HOME)
    ) {
      next({ path: BRAND_MODE_HOME });
      return;
    }

    // 3. 已登录访问根路径时，优先恢复上次访问地址
    if (isAuthenticated && to.path === "/") {
      const lastRoute = getLastRouteFromStorage();
      if (lastRoute && lastRoute !== "/") {
        next(lastRoute);
        return;
      }
    }

    // 4. 已登录且访问需要权限的页面，正常进入
    next();
  } catch (error) {
    console.error("路由导航错误:", error);
    // 导航错误时重定向到登录页或显示错误页面
    next({ path: "/login", query: { error: "navigation" } });
  } finally {
    // Route performance logging — dev/staging only
    if (process.env.NODE_ENV !== 'production') {
      console.log(`路由导航耗时: ${Date.now() - start}ms`, {
        from: from.path,
        to: to.path,
      });
    }
  }
});

// Scroll to top after each navigation completes
router.afterEach(() => {
  if (shouldPersistRoute(router.currentRoute)) {
    try {
      window.localStorage.setItem(LAST_ROUTE_STORAGE_KEY, router.currentRoute.fullPath);
    } catch (error) {
      console.warn("保存最后访问路由失败:", error);
    }
  }
  window.scrollTo(0, 0);
});

export default router;
